import React, { useEffect, useRef, useState } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";

import "./style/style.scss";
import "./style/animation.scss";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";
import useAnimation from "../../../../shared/hooks/useAnimation";
import ProgressBar from "../../../../shared/components/ProgressBar";
import GreenGlow from "../../_partials/GreenGlow";
import InsightZoneLogo from "../../_partials/InsightZoneLogo";
import GoalLine from "./goalLine";
import Goals from "./goals";
import _, { sortBy, split } from "lodash";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import getContentById from "../../../../shared/utils/getContentById";
import { getScaleSize } from "../Lineup/Index";
import borderFrameWhite from "./images/border_BG_empty.png";
import borderFrameRed from "./images/border_BG_empty.png";
import borderFrameBlack from "./images/border_BG_empty.png";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import { getImageFilterStyle, getWrapperDimensions } from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import { DEFAULT_ADJUSTMENTS } from "../../../../frontend/constants/constants.js";
import { PresetColors, ResultTimes } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab.js";
import { uefaID } from "../ImageTable/Index.jsx";

// const getMainBackground = () => {
//   return assets.background_1920;
// };

const getMainBackground = (format) => {
  if (format === "1200x1500") {
    return _.get(assets, `mainbackground_1200`);
  }

  if (format === "1080x1920") {
    return _.get(assets, `mainbackground_1080`);
  }
};


export const sortByTimeFirst = (arr) => {
  const getMinute = (timeStr) => {
    if (!timeStr) return 0;
    const base = timeStr.split('+')[0];
    return parseInt(base, 10);
  };

  return arr.sort((a, b) => {
    return getMinute(a.times[0]) - getMinute(b.times[0]);
  });
};

export const ratioFromFormat = (format) => {
  // return 0;
  if (format === '1920x1080') return 1.78;
  if (format === '1200x1500') return 0.8;
  return 0.56;
}

export const ratioStringFromFormat = (format) => {
  if (format === '1920x1080') return '16/9';
  if (format === '1200x1500') return '4/5';
  return '9/16';
}

export const parseMinute = (min) => {
  const s = String(min);
  if (s.includes('+')) {
    const [main, extra] = s.split('+').map(Number);
    return (Number.isNaN(main) ? 0 : main) * 100 + (Number.isNaN(extra) ? 0 : extra);
  }
  const n = Number(s);
  return (Number.isNaN(n) ? 0 : n) * 100;
};

export const formatMinute = (min) => {
  const s = String(min);
  if (s.includes('+')) {
    const [main, extra] = s.split('+');
    return `${main}'+${extra}`;
  }
  if (s.includes(' (P)')) {
    const [main, extra] = s.split(' (P)');
    return `${main}' (P)`;
  }
  if (s.includes(' (OG)')) {
    const [main, extra] = s.split(' (OG)');
    return `${main}' (OG)`;
  }
  if (parseInt(min) > 90) {
    const extra = parseInt(min) - 90;
    return `90'+${extra}`;
  }
  return `${s}'`;
};

const FCBResultsView = ({ animation, data, mode, format, prevRatio, _searchParams, ...props }) => {
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };
  useAnimation({
    mode,
    animation,
    id,
    animationScript,
    animationCleanUp,
    callback: prepareAnimation,
    apiSetup: props?.apiSetup,
    data,
  });

  const { fields, editData } = data.data;

  const {
    matchDetails = {},
    goalShots,
    lineUp,
    matchInfo,
  } = data?.data?.dynamic;
  const manualEntries = editData?.manualEntries;

  const matchStatus = matchDetails?.matchStatus;
  let currentMatchTime = matchDetails?.matchTime ?? matchDetails?.matchLengthMin ?? 0;
  const period = matchDetails?.period;
  let firstHalfExtra = 0;
  if (period) {
    firstHalfExtra = period?.[0].announcedInjuryTime / 60 ?? 0;
  }
  if (firstHalfExtra > 0) {
    currentMatchTime -= firstHalfExtra;
  }
  const scores = matchDetails?.scores || {
    total: {
      home: null,
      away: null
    }
  };
  const homeTeam = data.event.home;
  const awayTeam = data.event.away;

  const homeKit = lineUp?.find(
    ({ contestantId }) => contestantId === homeTeam.id,
  )?.player;
  const awayKit = lineUp?.find(
    ({ contestantId }) => contestantId === awayTeam.id,
  )?.player;

  const goals = goalShots?.filter(({ typeId }) => typeId === 16);
  const customBackground = getContentById("background", fields, "self");
  const homeScore = getContentById("homeScore", fields);
  const awayScore = getContentById("awayScore", fields);
  let showScore = true;

  if (!_.isEmpty(homeScore)) {
    _.set(scores, 'total.home', homeScore);
    showScore = true
  }

  if (!_.isEmpty(awayScore)) {
    _.set(scores, 'total.away', awayScore);
    showScore = true
  }

  const competitionId = matchInfo?.competition?.id;

  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );

  const [layers, setLayers] = useState([]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
    jersey: PresetColors.white,
    time: ResultTimes.halfTime,
    isPenalty: false,
  }
  const [effects, setEffects] = useState(defaultEffects)

  const awayContainerRef = useRef(null);
  const homeContainerRef = useRef(null);


  useEffect(() => {
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;

    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? defaultEffects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
        }
      }, 500);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      }
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: { width: newDimension.width, height: newDimension.height },
            originalDimensions: { width: newDimension.width, height: newDimension.height },
            nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
            adjustments: { ...DEFAULT_ADJUSTMENTS },
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: ""
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        // prevRatioRef.current = 0.56; //default
        setEffects(defaultEffects)
      }
      initializeLayers();
    }
  }, [editData, fields])

  const [ratioSize, setRatioSize] = useState({
    width: 4.075,
    height: 4.075
  });

  useEffect(() => {
    if (prevRatio) {
      setRatioSize(getScaleSize(format, prevRatio));
    } else {
      const editData = data?.data?.editData;
      if (editData) {
        setRatioSize(getScaleSize(format, ratioFromFormat(data.currentFormat)));
      } else {
        setRatioSize(getScaleSize(format, 0));
      }
    }
  }, [format, prevRatio])
  let homeGoalGroup;
  let homeGoalsFlat;
  let totalHomeGoals = 0;
  let awayGoalGroup;
  let awayGoalsFlat;
  let totalAwayGoals = 0;
  if (manualEntries && (manualEntries?.scores?.home || manualEntries?.scores?.away)) {
    homeGoalsFlat = manualEntries?.players?.home
      ?.filter((g) => g.min && g.name)
      .map((g) => ({
        playerName: g.name,
        timeMin: g.min,
        sortValue: parseMinute(g.min),
      }))
      .sort((a, b) => a.sortValue - b.sortValue) || [];

    totalHomeGoals = homeGoalsFlat.length;
    homeGoalGroup = Object.values(manualEntries?.players?.home?.reduce((acc, goal) => {
      if (!acc[goal.name] && goal.min && goal.name) {
        acc[goal.name] = {
          playerName: goal.name,
          times: [],
        };
      }
      if (goal.min && goal.name) {
        acc[goal.name].times.push(goal.min);
      }
      return acc;
    }, {}));

    homeGoalGroup = sortByTimeFirst(homeGoalGroup);

    awayGoalsFlat = manualEntries?.players?.away
      ?.filter((g) => g.min && g.name)
      .map((g) => ({
        playerName: g.name,
        timeMin: g.min,
        sortValue: parseMinute(g.min),
      }))
      .sort((a, b) => a.sortValue - b.sortValue) || [];

    totalAwayGoals = awayGoalsFlat.length;

    awayGoalGroup = Object.values(manualEntries?.players?.away?.reduce((acc, goal) => {
      if (!acc[goal.name] && goal.min && goal.name) {
        acc[goal.name] = {
          playerName: goal.name,
          times: [],
        };
      }
      if (goal.min && goal.name) {
        acc[goal.name].times.push(goal.min);
      }
      return acc;
    }, {}));

    awayGoalGroup = sortByTimeFirst(awayGoalGroup);
  } else {
    // homeGoalsFlat = goals
    //   .filter(g => (g.contestantId === homeTeam.id && !g.isOwnGoal) || (g.contestantId !== homeTeam.id && g.isOwnGoal))
    //   .map(g => {
    //     let p = homeKit.find(k => k.playerId === g.playerId);
    //     if (g.isOwnGoal) {
    //       p = awayKit.find(k => k.playerId === g.playerId);
    //     }
    //     return {
    //       playerId: g.playerId,
    //       playerName: (p?.shortLastName || g.playerName) + (g.isPenalty ? " (P)" : g.isOwnGoal ? " (OG)" : ""),
    //       timeMin: g.timeMin,
    //       sortValue: parseMinute(g.timeMin),
    //     };
    //   })
    //   .sort((a, b) => a.sortValue - b.sortValue);
    // totalHomeGoals = homeGoalsFlat.length;

    // homeGoalGroup = Object.values(
    //   goals.reduce((acc, goal) => {
    //     const isHome = (goal.contestantId === homeTeam.id && !goal.isOwnGoal) || (goal.contestantId !== homeTeam.id && goal.isOwnGoal);
    //     if (isHome) {
    //       if (!acc[goal.playerId]) {
    //         let _player = homeKit.find((k) => k.playerId === goal.playerId);
    //         if (goal.isOwnGoal) {
    //           _player = awayKit.find((k) => k.playerId === goal.playerId);
    //         }
    //         acc[goal.playerId] = {
    //           playerName: _player?.shortLastName || goal.playerName,
    //           times: [],
    //           isPenalty: goal.isPenalty,
    //           isOwnGoal: goal.isOwnGoal
    //         };
    //       }
    //       acc[goal.playerId].times.push((goal.timeMin) + (goal.isPenalty ? " (P)" : goal.isOwnGoal ? " (OG)" : ""));
    //     }

    //     return acc;
    //   }, {}),
    // );

    // awayGoalsFlat = goals
    //   .filter(g => (g.contestantId !== homeTeam.id && !g.isOwnGoal) || (g.contestantId === homeTeam.id && g.isOwnGoal))
    //   .map(g => {
    //     let p = awayKit.find(k => k.playerId === g.playerId);
    //     if (g.isOwnGoal) {
    //       p = homeKit.find(k => k.playerId === g.playerId);
    //     }
    //     return {
    //       playerId: g.playerId,
    //       playerName: (p?.shortLastName || g.playerName) + (g.isPenalty ? " (P)" : g.isOwnGoal ? " (OG)" : ""),
    //       timeMin: g.timeMin,
    //       sortValue: parseMinute(g.timeMin),
    //     };
    //   })
    //   .sort((a, b) => a.sortValue - b.sortValue);

    // totalAwayGoals = awayGoalsFlat.length;

    // awayGoalGroup = Object.values(
    //   goals.reduce((acc, goal) => {
    //     const isHome = (goal.contestantId === homeTeam.id && !goal.isOwnGoal) || (goal.contestantId !== homeTeam.id && goal.isOwnGoal);

    //     if (!isHome) {
    //       if (!acc[goal.playerId]) {
    //         let _player = awayKit.find((k) => k.playerId === goal.playerId);
    //         if (goal.isOwnGoal) {
    //           _player = homeKit.find((k) => k.playerId === goal.playerId);
    //         }
    //         acc[goal.playerId] = {
    //           playerName: _player?.shortLastName || goal.playerName,
    //           times: [],
    //         };
    //       }
    //       acc[goal.playerId].times.push((goal.timeMin) + (goal.isPenalty ? " (P)" : goal.isOwnGoal ? " (OG)" : ""));

    //     }

    //     return acc;
    //   }, {}),
    // )
  }
  const jersey = effects?.jersey;
  const time = effects?.time;
  const isPenalty = effects?.isPenalty;
  let borderFrame = borderFrameWhite;
  if (jersey === PresetColors.red) {
    borderFrame = borderFrameRed;
  } else if (jersey === PresetColors.black) {
    borderFrame = borderFrameBlack;
  }


  const event = data?.event;
  const isUEFA = event.competitionId === uefaID;

  // compute which items should show a comma after them
  const updateHomeCommas = () => {
    const homeContainer = homeContainerRef.current;
    if (!homeContainer) return;
    const items = Array.from(homeContainer.querySelectorAll(".goal-info"));
    // clear previous flags
    items.forEach(item => item.classList.remove("show-comma"));

    for (let i = 0; i < items.length - 1; i++) {
      const el = items[i];
      const next = items[i + 1];
      // compare y position (top). Use getBoundingClientRect for sub-pixel accuracy.
      const topA = Math.round(el.getBoundingClientRect().top);
      const topB = Math.round(next.getBoundingClientRect().top);
      if (topA === topB) {
        // same row -> show comma after this element
        el.classList.add("show-comma");
      }
    }
  };

  // compute which items should show a comma after them
  const updateAwayCommas = () => {
    const awayContainer = awayContainerRef.current;
    if (!awayContainer) return;
    const items = Array.from(awayContainer.querySelectorAll(".goal-info"));
    // clear previous flags
    items.forEach(item => item.classList.remove("show-comma"));

    for (let i = 0; i < items.length - 1; i++) {
      const el = items[i];
      const next = items[i + 1];
      // compare y position (top). Use getBoundingClientRect for sub-pixel accuracy.
      const topA = Math.round(el.getBoundingClientRect().top);
      const topB = Math.round(next.getBoundingClientRect().top);
      if (topA === topB) {
        // same row -> show comma after this element
        el.classList.add("show-comma");
      }
    }
  };

  useEffect(() => {
    updateHomeCommas();
    updateAwayCommas();
    // catch layout changes when fonts or images load
    window.addEventListener("load", updateHomeCommas);
    window.addEventListener("load", updateAwayCommas);

    // If the goalGroups change, re-run (good to watch props; rerun effect)
    return () => {
      window.removeEventListener("load", updateHomeCommas);
      window.removeEventListener("load", updateAwayCommas);
    };
  }, [homeGoalGroup, awayGoalGroup]);
  return (
    <div
      id={id}
      className={`T_${templateName} resultTemplate ${animation ? "animation" : ""}`}
    >
      <TemplateBlock>
        <div className={"custom-background-container"}>
          {isUEFA && <div className="ucl-gradient"></div>}
          <div
            id={_.get(customBackground, "id", null)}
            style={customBackgroundStyles}
            className={"custom-background"}
          >
            {layers
              .map((layer, index) => {
                const { id, adjustments, imageUrl, dimensions, x, y } = layer;
                const filterStyles = getImageFilterStyle(adjustments);
                const { colorOverlays = [], ...filterStyle } = filterStyles;
                return (
                  <div
                    style={{
                      position: 'absolute',
                      width: `${dimensions.width * ratioSize.width}px`,
                      height: `${dimensions.height * ratioSize.height}px`,
                      left: `${x * ratioSize.width}px`,
                      top: `${y * ratioSize.height}px`,
                      ...filterStyle
                    }}
                    key={id}
                  >
                    <img
                      src={imageUrl}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: "65%", // Adjust as needed
                        background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(20, 20, 20, 0.7) 40%, rgba(30,30,30,1) 100%)",
                        pointerEvents: "none",
                        zIndex: 2,
                      }}
                    />
                    {/* Color overlays */}
                    {colorOverlays.map((overlayStyle, i) => (
                      <div
                        key={i}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          pointerEvents: 'none',
                          ...overlayStyle
                        }}
                      />
                    ))}
                  </div>
                );
              })}
          </div>
        </div>

        <div className="wc-content" style={{ zIndex: 101 }}>

          <div className="content">
            <div className={`angled-border ${jersey === PresetColors.white ? "angle-border-white" : jersey === PresetColors.red ? "angle-border-red" : "angle-border-black"}`}>
              <img src={borderFrame} alt="border-frame" />
            </div>
            <div className="goal-block">
              <MatchScoreWidget
                homeTeam={homeTeam}
                awayTeam={awayTeam}
                scores={(manualEntries && (manualEntries?.scores?.home || manualEntries?.scores?.away)) ? { total: { ...manualEntries.scores } } : scores}
                matchStatus={matchStatus}
                matchDetails={matchDetails}
                competitionId={competitionId}
                matchInfo={matchInfo}
                showScore={showScore}
              />
              <div className="goals">
                <div
                  className={`home ${homeGoalGroup?.length < 4 ? "direction-column" : "direction-row"} home-goal-container`}
                  ref={homeContainerRef}
                >
                  {
                    totalHomeGoals <= 4 ? homeGoalsFlat?.map((goal, index) => {
                      return (
                        <div className="goal-info" key={index}>
                          <span className="name">{goal.playerName}</span>
                          <span className="time">{formatMinute(goal.timeMin)}</span>
                        </div>
                      )
                    }) : homeGoalGroup?.map((goalGroup, index) => {
                      const formatted = goalGroup.times.map(formatMinute).join(', ');
                      return (
                        <div className="goal-info" key={index}>
                          <span className="name">{goalGroup.playerName}</span>
                          <span className="time">
                            {formatted}
                          </span>
                        </div>
                      );
                    })
                  }
                </div>
                <div className="spaceText"></div>
                {
                  isPenalty && <div className="penalty-container">
                    <div className="penalty-score">
                      ({manualEntries?.scores?.penHome}-{manualEntries?.scores?.penAway})
                    </div>
                    <div className="penalty-label">
                      PEN.
                    </div>
                  </div>
                }
                <div
                  className={`away ${awayGoalGroup?.length < 4 ? "direction-column" : "direction-row"} away-goal-container`}
                  ref={awayContainerRef}
                >
                  {
                    totalAwayGoals <= 4 ? awayGoalsFlat?.map((goal, index) => {
                      return (
                        <div className="goal-info" key={index}>
                          <span className="time">{formatMinute(goal.timeMin)}</span>
                          <span className="name">{goal.playerName}</span>
                        </div>
                      )
                    }) : awayGoalGroup?.map((goalGroup, index) => {
                      const formatted = goalGroup.times.map(formatMinute).join(', ');
                      return (
                        <div className="goal-info" key={index}>
                          <span className="time">
                            {formatted}
                          </span>
                          <span className="name">{goalGroup.playerName}</span>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
              <div className="match-length">
                {
                  time
                }'
              </div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

export default FCBResultsView;
